export {
  DISPLAY_MODE_FULL_BREAKDOWN,
  DISPLAY_MODE_GROUPED,
  DISPLAY_MODE_ONE_LINER,
  GROUPED_LABEL_LABOUR,
  GROUPED_LABEL_MATERIALS,
} from "@/utils/invoice-display-mode";

import {
  DISPLAY_MODE_FULL_BREAKDOWN,
  DISPLAY_MODE_GROUPED,
  DISPLAY_MODE_ONE_LINER,
} from "@/utils/invoice-display-mode";

export const DISPLAY_MODES = [
  {
    value: DISPLAY_MODE_FULL_BREAKDOWN,
    label: "Full breakdown",
    description: "Every labour and material line, with names and rates",
    // Skeleton bar widths (px) previewing how many lines this mode shows.
    previewBars: [132, 98, 118, 80],
  },
  {
    value: DISPLAY_MODE_GROUPED,
    label: "Grouped",
    description: "Labour as one line, materials as one line, no names or rates",
    previewBars: [132, 118],
  },
  {
    value: DISPLAY_MODE_ONE_LINER,
    label: "One-liner",
    description: "Job name and total only, no labour or material detail",
    previewBars: [132],
  },
];
